import Pusher, { Channel } from 'pusher-js'
const pusherKey: string = process.env.REACT_APP_PUSHER_KEY || ''

class PusherService {
    private readonly pusher: Pusher
    private channel: Channel | null = null

    constructor() {
        this.pusher = new Pusher(pusherKey, {
            cluster: 'ap2',
        })
    }

    connect(userId: string) {
        if (this.channel) {
            return
        }

        this.channel = this.pusher.subscribe(userId)

        console.log('Subscribed:', userId)
    }

    disconnect() {
        if (!this.channel) return

        this.channel.unbind_all()
        this.pusher.unsubscribe(this.channel.name)

        console.log('Unsubscribed:', this.channel.name)

        this.channel = null
    }

    bind(event: string, callback: (data: any) => void) {
        this.channel?.bind(event, callback)
    }

    unbind(event: string, callback: (data: any) => void) {
        this.channel?.unbind(event, callback)
    }

    getChannel() {
        return this.channel
    }
}

export default new PusherService()
